module.exports = __webpack_public_path__ + "img/icon_email_gray.d1bc709.svg";